import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {GameNumberBadgeDefaultBox} from "./game-number-badge.default.box";
import {GameNumberBadgeMrGreenBox} from "./game-number-badge.mrgreen.box";
import {GameNumberBadgeWsopBox} from "./game-number-badge.wsop.box";

export const GameNumberBadgeBox = styledByTheme(GameNumberBadgeDefaultBox)
    .forMrGreen(GameNumberBadgeMrGreenBox)
    .forWsop(GameNumberBadgeWsopBox)
    .forWsopCip(GameNumberBadgeWsopBox)
    .apply();
